function SettingsButton(props) {
    return (
      <button {...props} className={'with-text'}>
        Set Timer!
      </button>
    );
  }
  
  export default SettingsButton;